const $ = require('lib/jquery')
require('jquery-ui/ui/keycode')

// this module just exports the list of keycodes in jquery-ui
// so that our modules can require them declaratively
module.exports = $.ui.keyCode
